var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86052 10.6676L5.04718 11.5141H6.22105H20.0526C20.2171 11.5141 20.3182 11.5684 20.3789 11.6316C20.4415 11.6967 20.5 11.812 20.5 12C20.5 12.188 20.4415 12.3033 20.3789 12.3684C20.3182 12.4316 20.2171 12.4859 20.0526 12.4859H6.22105H5.04718L5.86052 13.3324L10.0289 17.6704C10.2219 17.8712 10.2219 18.1569 10.0289 18.3578C9.99013 18.3982 9.93281 18.4365 9.86574 18.4645C9.79609 18.4934 9.74313 18.5 9.72632 18.5C9.64518 18.5 9.60019 18.4866 9.56911 18.4722C9.53525 18.4566 9.48979 18.4266 9.42369 18.3578L3.64474 12.3437C3.45175 12.1429 3.45175 11.8571 3.64474 11.6563L9.42369 5.64221C9.60589 5.4526 9.84674 5.4526 10.0289 5.64221L10.3885 5.2967L10.0289 5.64221C10.2219 5.84305 10.2219 6.12878 10.0289 6.32962L5.86052 10.6676Z",
    fill: "#0376C9",
    stroke: "#0376C9"
  })));
};
export default SvgBack;